import React from "react";

const BidForm = () => {
    return <div className='dashboard-inner'>Bid Form</div>
}
export default BidForm;